// extracted by mini-css-extract-plugin
export default {"container":"StudioVideos_container__D+8Zt","videoWrapper":"StudioVideos_videoWrapper__BQDkU","video":"StudioVideos_video__aqHal"};